module.exports = __webpack_public_path__ + "img/7c2d5ade-7567-4990-a8c4-8e056644fc5f.9d40dff3.png";